import { render, staticRenderFns } from "./EmailManager.vue?vue&type=template&id=d08c9c98&scoped=true&"
import script from "./EmailManager.vue?vue&type=script&lang=js&"
export * from "./EmailManager.vue?vue&type=script&lang=js&"
import style0 from "./EmailManager.vue?vue&type=style&index=0&id=d08c9c98&prod&lang=scss&scoped=true&"
import style1 from "./EmailManager.vue?vue&type=style&index=1&id=d08c9c98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08c9c98",
  null
  
)

export default component.exports